import React from "react";
import styled from "styled-components";

const CartColumns = () => {
  return (
    <Wrapper>
      <div className="content">
        <h5>Zboží</h5>
        <h5>Cena / den</h5>
        <h5>Počet</h5>
        <h5>Součet</h5>
        <span></span>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: none;
  @media (min-width: 776px) {
    display: block;
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid var(--clr-divider);
    .content {
      display: grid;
      grid-template-columns: 316px 1fr 1fr 1fr 44px;
      justify-items: center;
      column-gap: 1rem;
      align-items: center;
      h5 {
        color: var(--clr-charcoal-3);
        font-family: var(--ff-body);
        font-weight: 500;
        font-size: 0.8rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        margin: 0;
      }
      h5:first-child {
        justify-self: start;
      }
    }
  }
`;

export default CartColumns;
